<script setup>
import { modal_2026_ui_styles, close_button_2026_styles } from '~~/shared/utilities/ui'

const { $bus } = useNuxtApp();

const open = defineModel('open')
const router = useRouter()
const route = useRoute()

const cleanupBizzaboScripts = () => {
    const script = document.getElementById('bz-modal-registration-script');
    if (script) script.remove();
};

const addBizzaboScripts = () => {
    // Guard on the id this actually creates. It used to check
    // 'bizzabo-tickets-widget-script', which nothing here ever sets, so the
    // check never matched and every open of the modal appended ANOTHER
    // ticketsSelect script.
    const inlineId = 'bz-inline-registration-script-d5c532db-a94d-4036-aa53-8863432d30e4';
    const hasScript = document.getElementById(inlineId);

    if (!hasScript) {
        const bz = document.createElement('script');
        bz.id = inlineId;
        bz.type = 'text/javascript';
        // bz.async = true;
        bz.setAttribute('class', 'bz-inline-widget-script');
        bz.setAttribute('data-event-id', '951047');
        bz.src = 'https://organizer.bizzabo.com/widgets/flows/tickets/ticketsSelect.js';
        //const s = document.getElementsByTagName('script')[0];
        document.head.appendChild(bz);
    }
    
    const scriptId = 'bz-popup-registration-script-d5c532db-a94d-4036-aa53-8863432d30e4';
    const hasOtherScript = document.getElementById(scriptId);
    
    if (!hasOtherScript) {
        // Create the inline script first
        const inlineScript = document.createElement('script');
        inlineScript.id = scriptId;
        inlineScript.type = 'text/javascript';
        inlineScript.setAttribute('data-event-id', '951047');
        inlineScript.setAttribute('data-registration-proxy', 'true');
        inlineScript.setAttribute('data-unique-name', '951047');
        inlineScript.setAttribute('data-flow-id', 'd5c532db-a94d-4036-aa53-8863432d30e4');
        inlineScript.setAttribute('data-inline-widget', 'true');
        
        // Add the inline script content
        inlineScript.innerHTML = `
            (function() {
                var bz = document.createElement("script");
                bz.type = "text/javascript";
                bz.async = true;
                bz.setAttribute("data-flow-id","d5c532db-a94d-4036-aa53-8863432d30e4")
                bz.setAttribute("data-inline-widget", "true")
                bz.src = "https://organizer.bizzabo.com/widgets/flows/popup/registrationPopup.js";
                var s = document.getElementsByTagName("script")[0];
                s.parentNode.insertBefore(bz, s);
            })();
        `;
        document.head.appendChild(inlineScript);
    }
};

const handleClose = () => {
    const currentQuery = { ...route.query };
    delete currentQuery.modal;
    router.replace({ query: currentQuery });
}

// Use watch instead of @update:open for reliable triggering
watch(open, (val) => {
    if (val) {
        $bus.emit('drawer-open');
        // Wait for DOM to fully render before loading Bizzabo script
        nextTick(() => {
            setTimeout(() => {
                addBizzaboScripts();
            }, 1000);
        });
    }
    else {
        $bus.emit('drawer-close');
        cleanupBizzaboScripts();
        handleClose();
    }
});


onUnmounted(() => {
    cleanupBizzaboScripts();
});
</script>

<template>
    <UModal v-model:open="open" fullscreen :dismissible="false" title="Register" :close="close_button_2026_styles" description="Register for INBOUND" :ui="modal_2026_ui_styles" class="registration-modal registration-modal-2026">
        <template #body>
            <div class="modal-container">
                <h2 class="font-hubspot-serif text-[60px] leading-[1.1] tracking-normal text-[var(--magenta)] text-center mb-[18px]
                    max-md:text-[36px]">
                    Choose your pass and quantity:
                </h2>
                <p class="font-hubspot-sans font-light text-[16px] leading-[26px] tracking-[0.32px] text-[var(--magenta)] text-center mb-[32px]">
                    Get the details on the different pass types
                    <a href="/register" class="underline decoration-dotted underline-offset-[8.5%] text-[var(--magenta)] cursor-pointer hover:no-underline" @click.prevent="open = false; nextTick(() => navigateTo('/register'))">here</a>
                </p>
                <div
                    class="bz-widget-tickets-inline registration-widget"
                    data-flow-id="d5c532db-a94d-4036-aa53-8863432d30e4"
                    data-event-id="951047"
                    data-registration-proxy="true"
                    style="display: inline-flex; width: 100%;">
                </div>
                <button class="font-hubspot-sans font-light text-[14px] leading-[1.5] tracking-[0.28px]
                    text-[var(--magenta)] underline decoration-dotted underline-offset-[8.5%]
                    mt-[32px] bg-transparent border-none cursor-pointer
                    hover:no-underline"
                    @click="open = false">
                    Close
                </button>
            </div>
        </template>
    </UModal>
</template>

<style>
.bz-modal-body iframe {
    pointer-events: auto !important;
}

.registration-modal-2026 .modal-container {
    width: 100%;
    max-width: 1160px;
    margin: 0 auto;
    padding: 0 2rem 2rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: 1;
}

.registration-modal-2026 .registration-widget {
    min-height: 400px;
    width: 100%;
}
</style>
